export const environment = {
    production: false,
    msalConfig: {

        auth: {

            clientId: '890efbd1-fbbe-4d97-83ee-20c652cea4f2',

            authority: 'https://login.microsoftonline.com/0e17f90f-88a3-4f93-a5d7-cc847cff307e', // The Azure cloud instance and the app's sign-in audience (tenant ID, common, organizations, or consumers)
            redirectUri: "https://engtoolapp.engineeringhub.dev.gea.com/",
            postLogoutRedirectUri: "https://engtoolapp.engineeringhub.dev.gea.com/",
        },

    },
    apiScopes: ['api://890efbd1-fbbe-4d97-83ee-20c652cea4f2/access_as_user'],
    apiUrl: 'https://engtoolapi.engineeringhub.dev.gea.com',
    ioTestApiUrl: 'https://iotestapi.engineeringhub.dev.gea.com',
    apiUrlCodexAIDiagramGenius: 'https://codexaidiagramgenius-api-dev.azurewebsites.net/',
    websocketUrl: 'wss://enghubwebsocket.engineeringhub.dev.gea.com/ws/chat',
    mdgAdminUrl: 'https://admin.portal.tst.gea.com/mdg-customer'

};
